import { Directive, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { concat, forkJoin, of } from 'rxjs';
import { distinctUntilChanged, filter, mergeMap } from 'rxjs/operators';

import { AddressService } from './../services/address.service';

@Directive({
  selector: '[stateAutoComplete]',
})
export class StateAutoCompleteDirective implements OnInit {
  @Input('stateAutoComplete') addressFormGroup: UntypedFormGroup;

  get zipCodeControl() {
    return this.addressFormGroup.get('zip_code');
  }

  constructor(private addressService: AddressService) {}

  ngOnInit() {
    const zipCodeLimit = 5;

    if (this.zipCodeControl) {
      concat(of(this.zipCodeControl.value), this.zipCodeControl.valueChanges)
        .pipe(
          distinctUntilChanged(),
          filter(
            (zipcodeValue) =>
              zipcodeValue &&
              zipcodeValue.length &&
              zipcodeValue.length === zipCodeLimit,
          ),
          mergeMap((zipcodeValue) => {
            const state$ = this.addressService.getStateForZipCode(zipcodeValue);
            const county$ =
              this.addressService.getCountyNameForZipCode(zipcodeValue);

            return forkJoin([county$, state$]);
          }),
        )
        .subscribe(([countyName, stateCode]) => {
          const currentState = this.addressFormGroup.get('state');
          const currentCounty = this.addressFormGroup.get('county_name');

          // If state is not already set to the state code then update, else don't
          if (currentState && currentState.value !== stateCode) {
            this.addressFormGroup.patchValue({ state: stateCode });
          }

          if (currentCounty && currentCounty.value !== countyName) {
            this.addressFormGroup.patchValue({ county_name: countyName });
          }
        });
    }
  }
}
